import { Component } from '@verndale/core';
import { showFromBottom, hideFromTop } from '../helpers/motion';

class FeaturedIndividual extends Component {
  setupDefaults() {
    this.dom = {
      content: this.el.querySelector('.featured-panel__content')
    };

    this.dom.content.style.visiblity = 'hidden';
    this.handleResize();
  }

  addListeners() {
    window.addEventListener('resize', this.handleResize.bind(this));
    this.el.addEventListener('mouseover', this.handleMouseOver.bind(this));
    this.el.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
  }

  handleResize() {
    if (window.innerWidth < 768) {
      if (this.dom.content.anim) this.dom.content.anim.stop();
      this.mobile = true;
      this.dom.content.style.visibility = 'visible';
    } else {
      this.mobile = false;
    }
  }

  handleMouseOver() {
    if (!this.mobile) {
      this.dom.content.style.visibility = 'visible';
      if (this.dom.content.anim) this.dom.content.anim.stop();
      this.dom.content.anim = showFromBottom(
        this.dom.content,
        0.2,
        0.2,
        [0.11, 0, 0.5, 0]
      );
    }
  }

  handleMouseLeave() {
    if (!this.mobile) {
      if (this.dom.content.anim) this.dom.content.anim.stop();
      this.dom.content.anim = hideFromTop(
        this.dom.content,
        0.1,
        0.2,
        [0.11, 0, 0.5, 0]
      );
      this.dom.content.anim.finished.then(() => {
        this.dom.content.style.visibility = 'hidden';
      });
    }
  }
}

export default FeaturedIndividual;
